module.exports = __webpack_public_path__ + "static/img/IMG_20240105_091015.4f3af9b3.jpg";